import { render, staticRenderFns } from "./aColorPalette.vue?vue&type=template&id=3503592a&scoped=true"
import script from "./aColorPalette.vue?vue&type=script&lang=js"
export * from "./aColorPalette.vue?vue&type=script&lang=js"
import style0 from "./aColorPalette.vue?vue&type=style&index=0&id=3503592a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503592a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
